// extracted by mini-css-extract-plugin
export default {"divider":"style_divider__swuvS","l16":"style_l16__H7QVy","l60":"style_l60__8m3pE"};